import { useReduxState } from 'hooks';
import {
  Button,
  ContentLabel,
  ContentValue,
  DisplayFormattedDate,
  RichTextValue
} from 'components/common';
import { Box } from 'components/common/box';
import { CalendarEventFeedbackSettings } from '.';

const CalendarEventFeedbackSummary = () => {
  const {
    messages,
    pageState: { calendarEvent },
    theme
  } = useReduxState();

  const {
    feedbackAccessEndDate,
    feedbackAccessStartDate,
    feedbackAllowNonParticipated,
    feedbackAutomaticEmailEnabled,
    feedbackEnabled,
    feedbackInfoText
  } = calendarEvent;

  const statusColor = feedbackEnabled
    ? theme.successStandaloneColor
    : theme.textColorLight;

  return (
    <div className="summary">
      <Box
        headerContent={
          <Button
            category="lighter"
            href={`/calendar/${calendarEvent.id}/feedback?view=user`}
            icon="eye"
            size="header"
            text={messages.eventCalendarFeedbackPreviewAsParticipant}
          />
        }
        title={messages.commonFeedback}
      >
        <div className="info">
          <ContentLabel horizontal={true} label={messages.commonStatus}>
            <ContentValue
              icon={feedbackEnabled ? 'check-circle' : 'times-circle'}
              iconStyle={{ color: statusColor }}
              style={{
                color: statusColor,
                fontSize: '1.5rem',
                fontWeight: 600
              }}
            >
              {feedbackEnabled
                ? messages.commonEnabled
                : messages.commonDisabled}
            </ContentValue>
          </ContentLabel>

          <ContentLabel
            horizontal={true}
            label={messages.eventCalendarFeedbackWhoCanSubmit}
          >
            <ContentValue>
              {feedbackAllowNonParticipated
                ? messages.eventCalendarFeedbackAllowNonParticipated
                : messages.eventCalendarFeedbackParticipatedOnly}
            </ContentValue>
          </ContentLabel>

          <ContentLabel
            horizontal={true}
            label={messages.eventCalendarFeedbackOpenDate}
          >
            <ContentValue>
              {feedbackAccessStartDate ? (
                <DisplayFormattedDate
                  date={feedbackAccessStartDate}
                  withTime={true}
                />
              ) : (
                messages.eventCalendarFeedbackOpenDateNotSet
              )}
            </ContentValue>
          </ContentLabel>

          <ContentLabel
            horizontal={true}
            label={messages.eventCalendarFeedbackCloseDate}
          >
            <ContentValue>
              {feedbackAccessEndDate ? (
                <DisplayFormattedDate
                  date={feedbackAccessEndDate}
                  withTime={true}
                />
              ) : (
                messages.commonNever
              )}
            </ContentValue>
          </ContentLabel>

          <ContentLabel
            horizontal={true}
            label={messages.eventCalendarFeedbackAutomaticEmail}
          >
            <ContentValue>
              {feedbackAutomaticEmailEnabled
                ? messages.commonEnabled
                : messages.commonDisabled}
            </ContentValue>
          </ContentLabel>

          {feedbackInfoText ? (
            <ContentLabel
              horizontal={true}
              label={messages.eventCalendarFeedbackInfoText}
            >
              <ContentValue>
                <RichTextValue html={feedbackInfoText} />
              </ContentValue>
            </ContentLabel>
          ) : null}

          <div className="edit">
            <CalendarEventFeedbackSettings />
          </div>
        </div>
      </Box>

      <style jsx>{`
        .edit {
          margin-top: 25px;
        }
      `}</style>
    </div>
  );
};

export default CalendarEventFeedbackSummary;
